import React from "react";
import * as c from "./blogLayout.module.scss";
import Layout from "@components/layout";
import classNames from "classnames";
import { BlogSubscribeBanner } from "@components/blog/blogSubscribe";
import { Link } from "gatsby";
import ArrowIcon from "@icons/arrowIcon";

const BlogLayout = ({ className, children }) => {
  return (
    <>
      <Layout className={c.wrapper}>
        <div className={c.backgroundWrapper}>
          <div className={classNames(className, c.body)}>{children}</div>
          <BlogSubscribeBanner className={c.subscribeBanner} />
        </div>
      </Layout>
    </>
  );
};

BlogLayout.Header = ({ className, children }) => <div className={classNames(className, c.header)}>{children}</div>;
BlogLayout.Header.Breadcrumbs = ({ className, label = "All blog articles" }) => (
  <Link to="/blog/" className={classNames(className, c.breadcrumbs)}>
    <ArrowIcon direction="left" /> {label}
  </Link>
);
BlogLayout.Header.Headline = ({ className, label = "Mangomint Blog", useTitleCase = true }) => (
  <h1 className={classNames(className, c.headline, { [c.titleCase]: useTitleCase })}>{label}</h1>
);
BlogLayout.Section = ({ className, children }) => <div className={classNames(className, c.section)}>{children}</div>;
BlogLayout.Section.Headline = ({ className, label }) => (
  <h2 className={classNames(className, c.sectionHeadline)}>{label}</h2>
);

export { BlogLayout };
